import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n/I18nProvider";
import SEO from "@/components/SEO";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Calculator from "@/components/site/Calculator";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const HomePage = () => (
  <>
    <SEO />
    <Header />
    <main>
      <Hero />
      <Services />
      <Calculator />
      <About />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            richColors
            toastOptions={{ className: "font-body" }}
          />
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
